module.exports = __webpack_public_path__ + "static/02-7a2fddedeb96caf545dc8e4a23734b80.jpg";